import { render, staticRenderFns } from "./MerchantList.vue?vue&type=template&id=4f3f7218"
import script from "./MerchantList.vue?vue&type=script&lang=js"
export * from "./MerchantList.vue?vue&type=script&lang=js"
import style0 from "./MerchantList.vue?vue&type=style&index=0&id=4f3f7218&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports